<template>
  <div class="h-100">
    <div class="slide-out__top select-unit-head__slide-outdetails-view">
      <div class="select-unit-head__parent">
        <div class="select-unit-head__parent-title">{{ firstLevelTitle }}</div>
      </div>
      <!-- <div class="select-unit-head__controls">
        <button class="btn btn-primary" v-on:click="closeSlideOut()">Done</button>
      </div> -->
    </div>
    <div class="slide-out__body" ref="slideOutBody">
      <div class="slide-out__body-content" v-if="loading">
        <transition name="fade">
          <div class="overlay-state overlay-state-loading">
            <div class="overlay-state__body">
              <i class="overlay-state__icon far fa-spinner-third fa-spin"></i>
              <div class="overlay-state__header">Loading unit details</div>
              <div class="overlay-state__content">Please wait...</div>
            </div>
          </div>
        </transition>
      </div>
      <SlideOutUnitDetails
        :relationship="relationship" :location="location" :firstLevelTitle="firstLevelTitle" :allowEdit="false" :canComplete="$attrs.canComplete"
        :reviewMode="reviewMode" />
    </div>
  </div>
</template>

<script>
import SlideOutUnitDetails from './SlideOutUnitDetails.vue'
import SlideOutContainer from './SlideOutContainer.vue'
import { mapMutations } from 'vuex'

export default {
  props: {
    relationship: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    },
    firstLevelTitle: {
      type: String,
      required: true
    },
    reviewMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      scrollPos: 0
    }
  },
  computed: {
    unit() {
      return this.relationship.unit
    }
  },
  methods: {
    ...mapMutations('global', {
      closeSlideOut: 'closeSlideOut'
    })
  },
  components: { SlideOutContainer, SlideOutUnitDetails }
}
</script>
